import React from "react";
import { Link, NavLink } from "react-router-dom";
import mockqLogo from "../images/mockq-logo-dark.png"; // blue MockQ logo (transparent background)

const NAV_ITEMS = [
  { to: "/institute/dashboard", label: "Dashboard", icon: "bi-speedometer2" },
  { to: "/institute/students", label: "Students", icon: "bi-people" },
  { to: "/institute/exams", label: "Exams", icon: "bi-journal-check" },
  { to: "/institute/payments", label: "Payments", icon: "bi-credit-card" },
  { to: "/institute/scheduling", label: "Scheduling", icon: "bi-calendar-week" },
  { to: "/institute/results", label: "Results", icon: "bi-graph-up" },
];

export default function InstituteSidebar() {
  return (
    <aside className="admin-sidenav d-flex flex-column">
      <div className="admin-brand px-3 py-4">
        <Link
          to="/institute/dashboard"
          className="admin-brand-link"
          aria-label="MockQ institute dashboard"
        >
          <img src={mockqLogo} alt="MockQ" className="admin-brand-logo" />
        </Link>
        <p className="admin-brand-subtitle mb-0">Institute Panel</p>
      </div>

      <nav className="admin-nav flex-grow-1 overflow-auto py-2">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `admin-navitem d-flex align-items-center gap-2 ${
                isActive ? "active" : ""
              }`
            }
          >
            <i className={`bi ${item.icon}`} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}